export default __webpack_public_path__ + "static/media/18.5f04788e.jpg";